import { Modal, Typography } from 'antd';
import React, { useState } from 'react';
import { modal } from '../../../Tasks/configs/designTokens';
import '../../styles/index.scss';

const { Link } = Typography;

const GeneratedImagePixelTagModal = ({ appId, cart }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  return (
    <React.Fragment>
      <Modal
        title={'Image Pixel Instructions'}
        wrapClassName="tags-modal"
        width={modal.wide}
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        centered
        footer={null}
      >
        <>
          <iframe
            src={`${process.env.REACT_APP_INTERNAL_MICROSERVICE_URL}/api/docs/html?filename=onboarding%2Fimage-pixel${cart === 'ticketmaster' ? '-tm1' : ''}.md&appId=${appId}`} //eslint-disable-line
            title="image-pixel"
            width="100%"
            height="800px"
            allow="clipboard-read; clipboard-write"
            className="tags-modal__iframe"
          />
        </>
      </Modal>
        <Link onClick={() => setIsModalVisible(true)}>
          {cart === 'ticketmaster' ? 'Image Pixel (TM1)' : 'Image Pixel'}
        </Link>
    </React.Fragment>
  );
};

export default GeneratedImagePixelTagModal;
